<style lang="stylus" scoped>
@import '../cardMap.stylus';

.title {
  color: #999999;
  font-size: 14px;
}

span {
  margin-right: 15px;
  border-bottom: 3px solid transparent;
  color: #999999;
  display: inline-block;
  height: auto;
  line-height: 2;
  cursor: pointer;
}

.title span.active {
  background :#00927C;
}

div.title {
  position: relative;
}

.title span {
  font-size: 14px;
  color :#fff;
  padding :2px 30px;
  margin-right :0;
  background :#00A28A;
}
</style>
<template>
  <div class="title">
    <span
      v-for="(tit, index) in titleArr"
      :key="index"
      :class="{'active':index == (tab - 2)}"
      @click="change(index)"
    >{{tit.title}}</span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titleArr: [
        {
          title: '按车辆数降序排序'
        },
        {
          title: '按中国石油停靠次数降序排序'
        },
        {
          title: '按其他油站停靠次数降序排序'
        },
      ]
    }
  },
  computed: {},
  props: {
    changeType: {
      type: Function
    },
    tab: {
      type: String,
      default: '2'
    }
  },
  methods: {
    change(index) {
      this.changeType(index + 2 + '')
      //this.tab = index
    }
  }
}
</script>

